// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"a278e526","416":"235e0554","538":"a5bef68b","566":"b06c2d7e","614":"084c75c7","676":"37ad5407","882":"e846fd1e"}[chunkId] + ".chunk.js";
};